import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { reject } from 'lodash-es'

import { type NavigationLink } from '@/components/organisms/Navigation/Navigation.tsx'
import { type AppViewNavigation } from '@/components/templates/AppView/AppView.tsx'

import { AppPageDataContext } from '../AppPageDataProvider.tsx'

const REQUEST_STATUS: Array<NavigationLink['value']> = ['pending', 'assigned', 'allocated', 'onboarded', 'completed']

export const useActiveStatusSelector = (): Pick<AppViewNavigation, 'statusSelector'> => {
  const intl = useIntl()
  const { data } = useContext(AppPageDataContext)

  const statusSelector = useMemo(
    () =>
      REQUEST_STATUS.map((value) => ({
        title: intl.formatMessage(
          { id: `navigation.${value}` },
          {
            count: reject(data.requestList[value], { hidden: true })?.length ?? 0,
          }
        ),
        value,
      })),
    [intl, data.requestList]
  )

  return { statusSelector }
}
